import {combineReducers} from "redux";
import commonReducer from "./reducer";

const reducer = combineReducers({
    commonReducer,
})
  
export default reducer;